// `String(...)` on both sides, not `===`. The scope axes are stored as
// text and the pickers hold their ids as numbers, so `"106" === 106`
// was false and every id fell through to the fallback below — which is
// why the confirm-edit diff showed bare ids where it promised names
// (Curro, 2026-09-28). The real fix is coercing on read in
// `adapters.js`; this is the belt, because the same mismatch can arrive
// from any caller and it fails silently by design — a label is never
// missing, it is just wrong.
const toObject = (item, options) => {
	if (typeof item === 'object' && item !== null) return item
	const match = options.find(o => String(o.value) === String(item))
	return match ?? { value: item, label: String(item) }
}

const needsEnrich = arr => Array.isArray(arr) && arr.length > 0 && arr.some(i => typeof i !== 'object')

export function enrichFilterIds(fieldKey, options, drawerSignal, originalSignal) {
	if (needsEnrich(drawerSignal.peek()[fieldKey])) {
		drawerSignal.value = {
			...drawerSignal.value,
			[fieldKey]: drawerSignal.value[fieldKey].map(i => toObject(i, options)),
		}
	}
	if (originalSignal.peek() && needsEnrich(originalSignal.peek()[fieldKey])) {
		originalSignal.value = {
			...originalSignal.value,
			[fieldKey]: originalSignal.value[fieldKey].map(i => toObject(i, options)),
		}
	}
}
